<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <app-filter-item>
            <gj-select-input
                v-model="filter.code"
                :options="[ {id: 'code', text: '调拨单号'},
                {id: 'relevanceCode', text: '货件/发货单'},
                 {id: 'shipPlanCode', text: '发货计划'}]"
                :width="['100px', '120px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item>
            <gj-warehouse-select
                v-model="filter.warehouseIds"
                :fba="false"
                multiple
                placeholder="调出仓"
                width="160px"
            ></gj-warehouse-select>
          </app-filter-item>
          <app-filter-item>
            <gj-warehouse-select
                v-model="filter.arrivalWarehouseIds"
                multiple
                placeholder="调入仓"
                width="160px"
            ></gj-warehouse-select>
          </app-filter-item>
          <app-filter-item>
            <gj-select
                v-model="filter.statusList"
                collapse-tags
                width="150px"
                multiple
                :options="TransferOrderEnum.statusOption"
                placeholder="状态"
            ></gj-select>
          </app-filter-item>
          <app-filter-item priority="1">
            <gj-country-server-select
                v-model="filter.countryMarket"
            ></gj-country-server-select>
          </app-filter-item>
          <app-filter-item priority="2">
            <gj-creator-select
                v-model="filter.createUser"
                placeholder="创建人"
            ></gj-creator-select>
          </app-filter-item>
          <app-filter-item priority="3">
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '100px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item priority="4">
            <gj-select-date-picker
                v-model="filter.date"
                :options="option.date"
                :width="['120px']"
                type="daterange"
            ></gj-select-date-picker>
          </app-filter-item>
          <template #right>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"

            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('transfer:add')"
            type="primary"
            @click="add">
          添加
        </gj-button>
        <gj-button
            v-if="$permission('transfer:audit')"
            :disabled="noSelect || selectedSomeNotIn('status', [StatusEnum.DRAFT, StatusEnum.REJECTED])"
            @click="audit(selectedRows)">
          提审
        </gj-button>
        <gj-button
            v-if="$permission('transfer:audit')"
            :disabled="noSelect || selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)"
            @click="auditPass(selectedRows)">
          审核通过
        </gj-button>
        <gj-button
            v-if="$permission('transfer:audit')"
            :disabled="noSelect || selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)"
            @click="auditFail(selectedRows)">
          审核驳回
        </gj-button>
        <gj-button
            v-if="$permission('transfer:maintainShipment')"
            :disabled="maintainShipmentDisabled"
            @click="maintainFbaShipment(selectedRows)">
          维护货件
        </gj-button>
        <gj-button
            v-if="$permission('transfer:createShipment')"
            :disabled="createShipmentDisabled"
            @click="createFbaShipment(selectedRows)">
          创建货件
        </gj-button>
        <gj-button
            v-if="$permission('transfer:printLabels')"
            :disabled="printProductLabelDisabled"
            @click="printProductLabel(selectedRows)">
          打印商品标签
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            class="transfer-order"
            adaptParent
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            selection
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            :show-overflow="false"
            :bak-selected-rows="bakSelectedRows"
            :bak-rows="selectedRows"
            @clearBakSelectedRows="clearBakRows"
            :selectable="(row) => row.$gjParentData  && !row.$gjExtendRow"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [1, 13]}"
            sortable="custom"
            :pagination="pagination"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:picture="{row}">
            <template v-if="row.$gjParentData">
              <div style="display: inline-block; width: 150px;">
                {{row.code | defaultShow}}
                <gj-copy-icon :content="row.code"></gj-copy-icon>
              </div>
              <div v-gutter="20" style="display: inline-block;">
                <span><span class="parent-table-label">调出仓：</span><gj-text max-width="100px">{{row.warehouseName | defaultShow}}</gj-text></span>
                <span><span class="parent-table-label">调入仓：</span><gj-text max-width="100px">{{row.arrivalWarehouseName | defaultShow}}</gj-text></span>
                <span><span class="parent-table-label">店铺/国家：</span><gj-text max-width="100px">{{row.arrivalMarketName | defaultShow}}</gj-text></span>
                <gj-tag
                    type="plain"
                    shape="rectangle"
                    :color="row.status | optionColor(TransferOrderEnum.statusOption)">
                  {{ row.status | optionText(TransferOrderEnum.statusOption) }}
                </gj-tag>
                <span><span class="parent-table-label">总数量：</span>{{row.totalQuantity | defaultShow}}</span>
                <span><span class="parent-table-label">总实物重(g)：</span>{{row.totalPackageWeight | defaultShow}}</span>
                <span><span class="parent-table-label">总体积(CBM)：</span>{{row.totalVolume | defaultShow}}</span>
                <span><span class="parent-table-label">预期出运日期：</span>{{row.expectShipmentDate | defaultShow}}</span>
                <span><span class="parent-table-label">备注：</span><gj-text max-width="120px">{{row.memo | defaultShow}}</gj-text></span>
                <span><span class="parent-table-label">创建人：</span>{{row.createUserName | defaultShow}}</span>
                <span><span class="parent-table-label">创建时间：</span>{{row.createTime | defaultShow}}</span>
              </div>
            </template>
            <template v-else>
              <gj-image :src="row.skuImageUrl"></gj-image>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div class="text">
              <gj-text class="content">{{row.productName | defaultShow}}</gj-text>
            </div>
            <div class="text"><gj-text class="content">{{row.sku+row.sku+row.sku | defaultShow}}</gj-text></div>
            <div class="text"><gj-text class="content">{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</gj-text></div>
          </template>
          <template v-slot:msku="{row}">
            <div>{{row.msku | defaultShow}}</div>
            <div>{{row.fnsku | defaultShow}}</div>
            <div>{{row.asin | defaultShow}}</div>
          </template>
          <template v-slot:shipmentId="{row}">
            <template v-if="row.shipmentIdList && row.shipmentIdList.length > 0">
              <div v-for="(shipmentId, i) in row.shipmentIdList"
                   :key="i">{{shipmentId}}</div>
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:deliveryCode="{row}">
            <template v-if="row.relevanceShipNoteList && row.relevanceShipNoteList.length > 0">
              <div v-for="(rlCode, i) in row.relevanceShipNoteList" :key="i">
                <el-popover
                  popper-class="transfer-order-popper"
                  placement="left"
                  trigger="hover"
                  :content="`实际出运日期：${rlCode.actualShipDate || '-'}`">
                  <span slot="reference">{{rlCode.shipNoteCode | defaultShow}}</span>
                </el-popover>
              </div>
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:shipPlanCodeList="{row}">
            <template v-if="!row.$gjParentData">
              <template v-if="row.shipPlanCodeList && row.shipPlanCodeList.length !== 0">
                <el-dropdown>
                 <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{row.shipPlanCodeList[0] | defaultShow}} <i class="el-icon-arrow-down el-icon--right" v-if="row.shipPlanCodeList.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.shipPlanCodeList.length > 1">
                      <template v-for="(item,key) in row.shipPlanCodeList" >
                        <el-dropdown-item :key="key"><span style="font-size: 12px">{{ item }}</span></el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>
                -
              </template>
            </template>
          </template>
          <template v-slot:op="{ row }">
            <template v-if="row.$gjParentData">
              <gj-button-group
                  type="dropdown-op"
                  :config="opBtnConfig(row)"
              ></gj-button-group>
            </template>
          </template>
          <template v-slot:extend:row="{row}">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  更多（共{{row.num}}条）
                  <i class="iconfont iconzhankai"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  收起
                  <i class="iconfont iconshouqi"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, valueCheckMixin, bakSelectRowsMixin} from "@/minxins";
  import {TransferOrderEnum} from "./enum";
  import {
    abolishTransferOrder,
    auditTransferOrder, deleteTransferOrder,
    failTransferOrder,
    getTransferOrderPage, maintainTransferShipment, outboundTransferOrder,
    passTransferOrder
  } from "@/api/warehouse";
  import AppMaintainFbaShipmentModal from "./modal/maintain-shipment/maintain-fba-shipment-modal";
  import AppOpTransferOrderModal from "./modal/op/op-transfer-order-modal";
  import {OpEnum, ProductEnum} from "@/utils/options";
  import {defaultVal, isMeaningful, isMeaningless, unique} from "@/utils/common";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import model from './viewConfig'
  import AddFbaShipmentModal from "../../common/logistics/fba-shipment/modal/add/add-fba-shipment-modal";
  import AppPrintLabelModal from './modal/print-label-modal'
  import gjPopover from '@/components/popover/gj-popover.vue';
  const StatusEnum = TransferOrderEnum.status;

  export default {
    name: "app-transfer-order",
    mixins: [queryMixin, selectionMixin, responseMixin, valueCheckMixin, bakSelectRowsMixin],
    components: ['gjPopover'],
    data() {
      return {
        tableName: 'transferOrder',
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '190px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
          {id: 'packageWeight', header: '单品实物重(g)', field: 'packageWeight', width: '110px', align: 'right'},
          {id: 'volume', header: '单品体积(CBM)', field: 'volume', width: '115px', align: 'right'},
          {id: 'quantity', header: '数量', field: 'quantity', width: '100px', align: 'right'},
          {id: 'totalPackageWeight', header: '总实物重(g)', field: 'totalPackageWeight', width: '100px', align: 'right'},
          {id: 'totalVolume', header: '总体积(CBM)', field: 'totalVolume', width: '100px', align: 'right'},
          {id: 'shipmentId', header: '关联货件', field: 'slot:shipmentId', width: '150px'},
          {id: 'deliveryCode', header: '关联发货单', field: 'slot:deliveryCode', width: '160px'},
          {id: 'slot:shipPlanCodeList', header: '发货计划编号', field: 'slot:shipPlanCodeList', width: '180px'},
          {id: 'memo', header: '备注', field: 'memo', width: '300px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right'},
        ],
        opBtnConfig: (row) => [
          {
            label: '详情',
            click: () => this.view({...row, items: row.productsCopy})
          },
          {
            label: '编辑',
            show: () => this.$permission('transfer:add')
              && (row.status === StatusEnum.DRAFT || row.status === StatusEnum.REJECTED),
            click: () => this.edit({...row, items: row.productsCopy})
          },
          {
            label: '提审',
            show: () => this.$permission('transfer:audit')
              && (row.status === StatusEnum.DRAFT || row.status === StatusEnum.REJECTED),
            click: () => this.audit([{...row, items: row.productsCopy}])
          },
          {
            label: '拣货',
            show: () => this.$permission('transfer:add')
              && row.status === StatusEnum.WAIT_PICKED,
            click: () => this.pick({...row, items: row.productsCopy})
          },
          {
            label: '出库',
            show: () => this.$permission('transfer:add')
              && row.status === StatusEnum.WAIT_OUTBOUND,
            click: () => this.outbound([{...row, items: row.productsCopy}])
          },
          {
            label: '维护货件',
            show: () => this.$permission('transfer:maintainShipment')
              && this.someIs(row.status, [StatusEnum.WAIT_PICKED, StatusEnum.WAIT_OUTBOUND, StatusEnum.OUTBOUND])
              && row.arrivalMarketId !== '0',
            click: () => this.maintainFbaShipment([{...row, items: row.productsCopy}])
          },
          {
            label: '审核通过',
            show: () => this.$permission('transfer:audit')
              && row.status === StatusEnum.WAIT_REVIEW,
            click: () => this.auditPass([{...row, items: row.productsCopy}])
          },
          {
            label: '审核驳回',
            show: () => this.$permission('transfer:audit')
              && row.status === StatusEnum.WAIT_REVIEW,
            click: () => this.auditFail([{...row, items: row.productsCopy}])
          },
          {
            label: '删除',
            show: () => this.$permission('transfer:add')
              && row.status === StatusEnum.DRAFT,
            click: () => this.deleteItem({...row, items: row.productsCopy})
          },
          {
            label: '作废',
            show: () => this.$permission('transfer:abolish')
              && this.someIs(row.status, [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_PICKED, StatusEnum.WAIT_OUTBOUND, StatusEnum.OUTBOUND]),
            click: () => this.cancel([{...row, items: row.productsCopy}])
          },
          {
            label: '日志',
            click: () => this.viewLog({...row, items: row.productsCopy})
          },
        ],
        filter: {
          code: {
            key: 'code',
            value: null
          },
          relevanceCode: null,
          warehouseIds: null,
          arrivalWarehouseIds: null,
          statusList: null,
          countryMarket: null,
          createUser: null,
          keyword: {
            key: 'msku',
            value: null
          },
          date: {
            key: 'ExpectShipmentDate',
            value: null
          },
        },
        option: {
          keyword: [
            {id: 'msku', text: 'MSKU'},
            {id: 'fnsku', text: 'FNSKU'},
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
            {id: 'asin', text: 'ASIN'},
          ],
          date: [
            {id: 'ExpectShipmentDate', text: '预计出运日期'},
            {id: 'CreateTime', text: '创建时间'},
          ]
        },
        TransferOrderEnum: TransferOrderEnum,
        StatusEnum: StatusEnum,
        productTypeOption: ProductEnum.typeOption,
        moduleName: 'TRANSFER_ORDER',
        model
      }
    },
    computed: {
      maintainShipmentDisabled() {
        /**
         * 维护货件是否可操作，以下情况不可操作
         * 1、未选择数据
         * 2、数据状态不为待拣货、待出库、已出库
         * 3、数据中的目的站点不为fba站点
         * 4、数据中的目的站点不唯一
         */
        return this.noSelect
          || this.selectedSomeNotIn('status', [StatusEnum.WAIT_PICKED, StatusEnum.WAIT_OUTBOUND, StatusEnum.OUTBOUND])
          || this.selectedRows.some(item => isMeaningless(item.arrivalMarketId) || item.arrivalMarketId === '0')
          || unique(this.selectedRows, 'arrivalMarketId').length > 1;
      },
      createShipmentDisabled() {
        return this.noSelect
          || this.selectedSomeNotIn('status', [StatusEnum.WAIT_PICKED, StatusEnum.WAIT_OUTBOUND, StatusEnum.OUTBOUND])
          || this.selectedRows.some(item => isMeaningless(item.arrivalMarketId) || item.arrivalMarketId === '0')
          || unique(this.selectedRows, 'arrivalMarketId').length > 1;
      },
      /*
      * 打印商品标签，以下情况不可操作
      * 1、未选择数据
      * 2、调入仓不为FBA
      */
      printProductLabelDisabled(){
        return this.noSelect
          || this.selectedRows.some(item => isMeaningless(item.arrivalMarketId) || item.arrivalMarketId === '0')
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQueryInitParams() {
        return {
          filter: {
            code: {
              key: 'code',
              value: null
            },
            relevanceCode: null,
            warehouseIds: null,
            arrivalWarehouseIds: null,
            statusList: null,
            countryMarket: null,
            createUser: null,
            keyword: {
              key: 'msku',
              value: null
            },
            date: {
              key: 'ExpectShipmentDate',
              value: null
            },
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const countryMarket = this.filter.countryMarket;
        const date = this.filter.date.value;
        const params = {
          model: {
            [this.filter.code.key]: this.filter.code.value,
            // relevanceCode: this.filter.relevanceCode,
            warehouseIds: this.filter.warehouseIds,
            arrivalWarehouseIds: this.filter.arrivalWarehouseIds,
            statusList: this.filter.statusList,
            countryCodes: isMeaningful(countryMarket) ? countryMarket.countryIds : null,
            arrivalMarketIds: isMeaningful(countryMarket) ? countryMarket.marketIds : null,
            createUser: defaultVal(this.filter.createUser),
            [this.filter.keyword.key]: this.filter.keyword.value,
            [`start${this.filter.date.key}`]: date ? convertToDate(date[0]) : null,
            [`end${this.filter.date.key}`]: date ? convertToDate(date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getTransferOrderPage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const items = this._.cloneDeep(v.items)
              return Object.assign(v, {
                productsCopy: items,
                items: items ? items.slice(0, 3) : [],
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      add() {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            opType: OpEnum.type.ADD,
            header: '添加调拨单',
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      edit(row) {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            opType: OpEnum.type.UPDATE,
            header: `编辑调拨单<span class="modal-secondary-title">${row.code}</span>`,
            transferOrder: row
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      view(row) {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            header: row.code,
            opType: OpEnum.type.VIEW,
            transferOrder: row
          },
          on: {
            resetPage: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      audit(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '提审确认',
            content: rows.length === 1
              ? `确定要提审[${rows[0].code}]吗？`
              : `已选中 ${rows.length} 个调拨单，确定要批量提审吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              auditTransferOrder(rows.map(e => e.id))
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      auditPass(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '审核确认',
            content: rows.length === 1
              ? `确定要通过[${rows[0].code}]吗？`
              : `已选中 ${rows.length} 个调拨单，确定要批量通过吗？`,
            contentStyle: {'color': '#333', 'font-size': '12px'}
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              passTransferOrder(rows.map(e => e.id))
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      auditFail(rows) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: rows.length > 1 ? '驳回' : `驳回<span class="modal-secondary-title">${rows[0].code}</span>`,
            label: '驳回理由',
            labelWidth: '75px',
            contentStyle: {padding: '18px 40px 4px 30px'}
          },
          on: {
            submit: (memo) => {
              modal.confirmLoading = true;
              failTransferOrder({
                ids: rows.map(row => row.id),
                memo,
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      maintainFbaShipment(rows) {
        this.$gjCreate(AppMaintainFbaShipmentModal, {
          props: {
            transferOrders: rows,
          },
          on: {
            maintained: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      createFbaShipment(rows) {
        this.$gjCreate(AddFbaShipmentModal, {
          props: {
            transferOrders: rows,
          },
          on: {
            created: (shipmentIds) => {
              if (!this._.isEmpty(shipmentIds)) {
                maintainTransferShipment({
                  ids: rows.map(item => item.id),
                  shipmentIdList: shipmentIds,
                })
                  .then(res => {
                    this.$gjResponseHandle(res, () => {}, () => {
                      this.$gjMessage.error('关联货件与调拨单失败');
                    })
                  });
              }
              this.$gjResetPage();
            }
          }
        })
      },
      printProductLabel(rows){
        this.$gjCreate(AppPrintLabelModal,{
          props:{
            ids:rows.map(item=>item.id)
          },
          on:{
            created:()=>{}
          }
        })
      },
      pick(row) {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            header: row.code,
            opType: OpEnum.type.VIEW,
            transferOrder: row,
            pick: true
          },
          on: {
            resetPage: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      outbound(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '出库确认',
            content: rows.length === 1
              ? `确定要出库[${rows[0].code}]吗？出库后，该调拨单状态更新为“已出库”`
              : `已选中 ${rows.length} 个调拨单，确定要出库吗？出库后，调拨单状态更新为“已出库”`,
            contentStyle: {'color': '#333', 'font-size': '12px'}
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              outboundTransferOrder(rows[0].id)
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      deleteItem(row) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: `确定要删除[${row.code}]吗？删除后无法恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteTransferOrder({
                ids: row.id
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      cancel(rows) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: rows.length > 1 ? '作废' : `作废<span class="modal-secondary-title">${rows[0].code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '16px 20px'},
            notMargin: true
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              abolishTransferOrder(rows[0].id, reason)
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/transfer/logPage',
            params: {
              model: {
                transferId: row.id
              },
            },
            columns: TransferOrderEnum.logColumns
          }
        });
      },
      openDetail(row, flag){
        if (flag) {
          row.items = row.productsCopy;
          row.expand = flag;
        } else {
          row.items = row.items.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.expand = row.expand
            v.items = row.items
          }
          return v
        })
        this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
      }
    }
  }
</script>

<style lang="scss" scoped>
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
.text,.content,p{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:190px;
}
.transfer-order /deep/ .vxe-table--render-default .vxe-cell{
  white-space: nowrap;
}
.default {
  /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>

